const MOBILE_BREAKPOINT = 768

export default {
  data() {
    return {
      isNarrowViewport: typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT
    }
  },
  mounted() {
    this.updateViewportWidth = () => {
      this.isNarrowViewport = window.innerWidth <= MOBILE_BREAKPOINT
    }
    window.addEventListener('resize', this.updateViewportWidth)
  },
  beforeDestroy() {
    if (this.updateViewportWidth) window.removeEventListener('resize', this.updateViewportWidth)
  }
}
